<!-- 采购记账单-退货的时候用 -->
<template>
  <el-dialog title="选择采购记账单" :visible.sync="dialogVisible" width="90%" append-to-body center top="2rem">
    <subComponents ref="showSelectData"></subComponents>
    <div class='components_content_box'>
      <div class="components_content_top">
        <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item label="采购记账单号">
            <el-input v-model.trim="getRequestData.psbkmId" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="采购员">
            <el-select filterable v-model="getRequestData.psbkmPurchaser">
              <el-option label="全部" value="">
              </el-option>
              <el-option v-for="(values,keys) in userOneList" :key="keys" :label="values.opmName" :value="values.opmId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="components_content_content">
        <el-table stripe :data="returnData.list" border :row-key="getRowKeys" :expand-row-keys="expands" @expand-change="expandSelect" height="100%" highlight-current-row>
          <el-table-column type="expand" label="详情" width="70">
            <template slot-scope="props">
              <el-tabs type="border-card">
                <el-tab-pane label="辅助信息">
                  <el-table :data="[props.row.pisOrderauxinfVo]" border>
                    <el-table-column prop="coName" label="货主名称">
                    </el-table-column>
                    <el-table-column prop="psaiAccperiod" label="账期">
                    </el-table-column>
                    <el-table-column prop="psaiDeptime" label="起运时间">
                      <template slot-scope="scope">
                        <div v-if="scope.row.psaiDeptime">
                          {{$common.getLocalTime(scope.row.psaiDeptime)}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="psaiExptime" label="预到货时间">
                      <template slot-scope="scope">
                        <div v-if="scope.row.psaiExptime">
                          {{$common.getLocalTime(scope.row.psaiExptime)}}
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column prop="psaiCarricus" label="承运单位">
                    </el-table-column>
                    <el-table-column prop="psaiCarrier" label="承运人">
                    </el-table-column>
                    <el-table-column prop="psaiPaymethod" label="付款方式">
                    </el-table-column>
                    <el-table-column prop="psaiSettmethod" label="结算方式">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="明细">
                  <div style="margin-bottom: .5rem;">
                    <el-button @click="selectDataAction" size="mini">确定选择</el-button>
                  </div>
                  <el-table :ref="'detailTable'+props.$index" :data="props.row.detailVoList" height="400px" @selection-change="handleSelectionChange" border style="width: 100%">
                    <el-table-column type="selection" width="40">
                    </el-table-column>
                    <el-table-column prop="bgmName" label="通用名称">
                    </el-table-column>
                    <el-table-column prop="bgmManufacturer" label="生产厂商">
                    </el-table-column>
                    <el-table-column prop="bgmSpecifications" label="规格">
                    </el-table-column>
                    <el-table-column prop="bgmPlaceorigin" label="产地">
                    </el-table-column>
                    <el-table-column prop="psbkdBatnumber" label="批号">
                    </el-table-column>
                    <el-table-column prop="psbkdProdate" label="生产日期">
                      <template slot-scope="scope">
                        <div v-if="scope.row.psbkdProdate">
                          {{$common.getLocalTime(scope.row.psbkdProdate)}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="psbkdEffdate" label="有效期">
                      <template slot-scope="scope">
                        <div v-if="scope.row.psbkdEffdate">
                          {{$common.getLocalTime(scope.row.psbkdEffdate)}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="psbkdIsnumber" label="入库数量">
                    </el-table-column>
                    <el-table-column prop="returnNum" label="已经退货数量">
                    </el-table-column>
                    <el-table-column prop="psbkdPrice" label="单价">
                    </el-table-column>
                    <el-table-column prop="psbkdMoney" label="金额">
                    </el-table-column>
                    <el-table-column prop="psbkdPsmoney" label="含税金额">
                    </el-table-column>
                    <el-table-column prop="psbkdPsprice" label="含税价格">
                    </el-table-column>
                    <el-table-column prop="psbkdIntaxrate" label="进项税率">
                    </el-table-column>
                    <el-table-column prop="psbkdSbnumber" label="灭菌批号">
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
          </el-table-column>
          <el-table-column prop="depName" label="业务部门">
          </el-table-column>
          <el-table-column prop="psbkmPurchaserName" label="采购员">
          </el-table-column>
          <el-table-column prop="smName" label="购进单位">
          </el-table-column>
          <el-table-column prop="psbkmSsalesmanName" label="供应商业务员">
          </el-table-column>
          <el-table-column prop="psbkmTotalnumber" label="总数量">
          </el-table-column>
          <el-table-column prop="psbkmTotalcount" label="总条目数">
          </el-table-column>
          <el-table-column prop="psbkmTotalmoney" label="总金额">
          </el-table-column>
          <el-table-column prop="psbkmRemark" label="备注">
          </el-table-column>
          <el-table-column prop="psbkmRedate" label="记账日期">
            <template slot-scope="scope">
              {{$common.getLocalTime(scope.row.psbkmRedate)}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="components_content_bottom">
        <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30"
          layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: "purchaseOrderTemplate",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      getRequestData: {
        psbkmBuycus: "",
        psbkmId: "",
        psbkmPurchaser: "",
        smName: "",
        page: 1,
        rows: 30,
        start: "",
        end: "",
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      userOneList: [],
      expands: [],
      selectedDetailsList: [],
      getRowKeys(row) {
        // 行数据的Key
        return row.psbkmId;
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.smName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.psbkmPurchaser = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    // table每次只能展开一行
    expandSelect(row, expandedRows) {
      console.log(expandedRows);
      this.expands = [];
      if (expandedRows.length > 0) {
        row ? this.expands.push(row.psbkmId) : "";
        this.selectedDetailsList = [];
      }
    },
    async isShowData(name, value) {
      console.log(name);
      // switch(name){
      // 	case 'psbkmPurchaser':
      // 		var dataInfo = JSON.parse(sessionStorage.getItem('selectSupplierData'))
      // 		this.getRequestData.psbkmPurchaser = dataInfo.smId
      // 		this.getRequestData.smName = dataInfo.smName
      // 	default:
      // 		this.getRequestData[name] = value

      // }
    },
    // 获取采购员
    async getSpecialUser() {
      let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 });
      if (responseData.status == 200) {
        this.userOneList = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    openBox() {
      this.getDataList();
      this.dialogVisible = true;
      this.selectedDetailsList = [];
    },
    handleSelectionChange(data) {
      this.selectedDetailsList = data;
      console.log(this.selectedDetailsList);
    },

    selectDataAction() {
      if (this.selectedDetailsList.length <= 0) {
        this.$message({
          message: "未选择明细数据",
          type: "error",
        });
        return false;
      }
      this.dialogVisible = false;
      this.$parent.extractData(this.selectedDetailsList);
    },

    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.getPurchaseListOrderTwo(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getSpecialUser();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.table_content_tag {
  margin-right: 1rem;
}
.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>
